import buildQueryString from './buildQueryString';

const getHeaders = (extra = {}) => {
    const isBrowser = typeof window !== 'undefined';
    const headers = isBrowser ? new Headers() : {};

    Object.keys(extra).forEach(key => {
        if (isBrowser) {
            headers.append(key, extra[key]);
        } else {
            headers[key] = extra[key];
        }
    });

    return headers;
};

/**
 * @typedef {Object} FetchOptions
 * @property {('GET'|'POST'|'PUT'|'DELETE')} method
 * @property {String} path Relative path
 * @property {Object} data Request body / query options
 * @property {String} baseUrl Base URL. Defaults to `process.env.WP_CART_URL`
 *
 * @param {FetchOptions}
 */
const request = ({ method, path, data, baseUrl = process.env.WP_CART_URL }) => {

    let url = baseUrl + path;
    /**
     * {RequestInit}
     */
    const fetchOpts = {
        method,
    };

    if (method === 'GET') {
        fetchOpts.headers = getHeaders();
        if (data) {
            const prefix = url.indexOf('?') > -1 ? '&' : '?';
            const queryString = buildQueryString(data);

            url += prefix + queryString;
        }
    } else {
        fetchOpts.headers = getHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        });
        fetchOpts.body = buildQueryString(data);
    }

    return fetch(url, fetchOpts)
        .then(response => response.json())
        .catch(err => {
            console.error(`Unable to fetch and parse as JSON from '${url}'`, {
                method,
                baseUrl,
                path,
                data,
                fetchOpts,
            });

            throw err;
        });
};

export const get = (path, data, baseUrl) =>
    request({
        method: 'GET',
        path,
        data,
        baseUrl,
    });

export const post = (path, data, baseUrl) =>
    request({
        method: 'POST',
        path,
        data,
        baseUrl,
    });

export const put = (path, data, baseUrl) =>
    request({
        method: 'PUT',
        data,
        baseUrl,
        path,
    });

export const del = (path, data, baseUrl) =>
    request({
        method: 'DELETE',
        data,
        baseUrl,
        path,
    });
